module.exports = __webpack_public_path__ + "static/media/live_background.c0872187.png";